var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardGroupDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8253 13.0465H13.6835V9.85742H10.4709V13.0465H8.3291L12.0772 16.7671L15.8253 13.0465ZM11.5418 14.1095V10.9204H12.6127V14.1095H13.2391L12.0772 15.2629L10.9153 14.1095H11.5418ZM8.3291 17.8301H15.8253V18.8931H8.3291V17.8301Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7295 0H2.10421C0.946894 0 0 0.940909 0 2.09091V16.7273H2.10421V2.09091H14.7295V0ZM17.8858 4.18182H6.31263C5.15531 4.18182 4.20842 5.12273 4.20842 6.27273V20.9091C4.20842 22.0591 5.15531 23 6.31263 23H17.8858C19.0431 23 19.99 22.0591 19.99 20.9091V6.27273C19.99 5.12273 19.0431 4.18182 17.8858 4.18182ZM17.8858 20.9091H6.31263V6.27273H17.8858V20.9091Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardGroupDownload);
export default __webpack_public_path__ + "static/media/card-group-download.12f15fe61ef9aa7e8148fe41ed10a933.svg";
export { ForwardRef as ReactComponent };